import script from "./secondPregnancyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./secondPregnancyPage.vue?vue&type=script&setup=true&lang=js"

import "./secondPregnancyPage.vue?vue&type=style&index=0&id=020506ca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-020506ca"]])

export default __exports__